/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SMRuleFormConfiguration,
    SMRuleFormConfigurationFromJSON,
    SMRuleFormConfigurationToJSON,
    SMRuleFormData,
    SMRuleFormDataFromJSON,
    SMRuleFormDataToJSON,
    SMRuleFormValidationData,
    SMRuleFormValidationDataFromJSON,
    SMRuleFormValidationDataToJSON,
    SMSearchListItem,
    SMSearchListItemFromJSON,
    SMSearchListItemToJSON,
    SMSearchListQuery,
    SMSearchListQueryFromJSON,
    SMSearchListQueryToJSON,
} from '../models';

export interface ApiSearchManagerSMRuleFormConfigurationGetRequest {
    brand?: number;
    market?: string;
}

export interface ApiSearchManagerSMRuleFormCreatePostRequest {
    sMRuleFormData?: SMRuleFormData;
}

export interface ApiSearchManagerSMRuleFormDataGetRequest {
    id?: string;
}

export interface ApiSearchManagerSMRuleFormDeleteSearchDeleteRequest {
    id?: string;
}

export interface ApiSearchManagerSMRuleFormSearchesPostRequest {
    sMSearchListQuery?: SMSearchListQuery;
}

export interface ApiSearchManagerSMRuleFormUpdatePostRequest {
    sMRuleFormData?: SMRuleFormData;
}

export interface ApiSearchManagerSMRuleFormValidatePostRequest {
    sMRuleFormData?: SMRuleFormData;
}

/**
 * no description
 */
export class SMRuleFormApi extends runtime.BaseAPI {

    /**
     */
    async apiSearchManagerSMRuleFormConfigurationGetRaw(requestParameters: ApiSearchManagerSMRuleFormConfigurationGetRequest): Promise<runtime.ApiResponse<SMRuleFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.brand !== undefined) {
            queryParameters['brand'] = requestParameters.brand;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManager/SMRuleForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SMRuleFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchManagerSMRuleFormConfigurationGet(requestParameters: ApiSearchManagerSMRuleFormConfigurationGetRequest): Promise<SMRuleFormConfiguration> {
        const response = await this.apiSearchManagerSMRuleFormConfigurationGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchManagerSMRuleFormCreatePostRaw(requestParameters: ApiSearchManagerSMRuleFormCreatePostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManager/SMRuleForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SMRuleFormDataToJSON(requestParameters.sMRuleFormData),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiSearchManagerSMRuleFormCreatePost(requestParameters: ApiSearchManagerSMRuleFormCreatePostRequest): Promise<string> {
        const response = await this.apiSearchManagerSMRuleFormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchManagerSMRuleFormDataGetRaw(requestParameters: ApiSearchManagerSMRuleFormDataGetRequest): Promise<runtime.ApiResponse<SMRuleFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManager/SMRuleForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SMRuleFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchManagerSMRuleFormDataGet(requestParameters: ApiSearchManagerSMRuleFormDataGetRequest): Promise<SMRuleFormData> {
        const response = await this.apiSearchManagerSMRuleFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchManagerSMRuleFormDeleteSearchDeleteRaw(requestParameters: ApiSearchManagerSMRuleFormDeleteSearchDeleteRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManager/SMRuleForm/DeleteSearch`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSearchManagerSMRuleFormDeleteSearchDelete(requestParameters: ApiSearchManagerSMRuleFormDeleteSearchDeleteRequest): Promise<void> {
        await this.apiSearchManagerSMRuleFormDeleteSearchDeleteRaw(requestParameters);
    }

    /**
     */
    async apiSearchManagerSMRuleFormSearchesPostRaw(requestParameters: ApiSearchManagerSMRuleFormSearchesPostRequest): Promise<runtime.ApiResponse<Array<SMSearchListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManager/SMRuleForm/Searches`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SMSearchListQueryToJSON(requestParameters.sMSearchListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SMSearchListItemFromJSON));
    }

    /**
     */
    async apiSearchManagerSMRuleFormSearchesPost(requestParameters: ApiSearchManagerSMRuleFormSearchesPostRequest): Promise<Array<SMSearchListItem>> {
        const response = await this.apiSearchManagerSMRuleFormSearchesPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchManagerSMRuleFormUpdatePostRaw(requestParameters: ApiSearchManagerSMRuleFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManager/SMRuleForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SMRuleFormDataToJSON(requestParameters.sMRuleFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSearchManagerSMRuleFormUpdatePost(requestParameters: ApiSearchManagerSMRuleFormUpdatePostRequest): Promise<void> {
        await this.apiSearchManagerSMRuleFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiSearchManagerSMRuleFormValidatePostRaw(requestParameters: ApiSearchManagerSMRuleFormValidatePostRequest): Promise<runtime.ApiResponse<SMRuleFormValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManager/SMRuleForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SMRuleFormDataToJSON(requestParameters.sMRuleFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SMRuleFormValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchManagerSMRuleFormValidatePost(requestParameters: ApiSearchManagerSMRuleFormValidatePostRequest): Promise<SMRuleFormValidationData> {
        const response = await this.apiSearchManagerSMRuleFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
